import { yupResolver } from '@hookform/resolvers/yup';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button, Grid } from '@mui/material';
import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form';
import * as Yup from "yup";
import InputFormControl from './controls/InputFormControl';
import InputCheckboxFormControl from './controls/InputCheckboxFormControl';

interface EditUserProps {
    isOpenDialog: boolean;
    userDetails: any;
    onEditUser: (id: any, isAdmin: boolean, isHR: boolean) => void;
    handleCloseEditUserPopup: (isShowPopup: boolean) => void
}
const EditUser: React.FC<EditUserProps> = (props) => {
    const [openDialog, setOpenDialog] = React.useState(false);
    const handleCloseDialog = () => {
        setOpenDialog(false);
        props.handleCloseEditUserPopup(false);
    };

    const handleDialog = () => {
        setOpenDialog(props.isOpenDialog);
    };
    //const EMAIL_REGX = new RegExp(/.+@(psychmc|integratedtelehealth)\.com$/);
    const validationSchema = Yup.object()
        .shape({
            //email: Yup.string().email().required().matches(EMAIL_REGX, "Invalid email address. It support only psychmc.com email."),
            //email: Yup.string().email().required("Please enter email address"),
            // firstName: Yup.string().required("First name is required"),
            // lastName: Yup.string().required("Last name is required"),
            // title: Yup.string().required("title is required"),
            isAdmin: Yup.boolean(),
            isHR: Yup.boolean(),
        }).required();

    const {
        handleSubmit,
        control,
        setValue,
        formState: { errors },
    } = useForm({
        resolver: yupResolver(validationSchema),
    });

    useEffect(() => {
        if (props.userDetails.id === 0) {
            setValue("isAdmin", false);
            setValue("isHR", false);
            // setValue("firstName", "");
            // setValue("lastName", "");
            // setValue("title", "");
        }
        else {
            setValue("isAdmin", props.userDetails.role === "Administrator");
            setValue("isHR", props.userDetails.role === "HR");
            // setValue("firstName", props.userDetails.firstName);
            // setValue("lastName", props.userDetails.lastName);
            // setValue("title", props.userDetails.designation);
            // setValue("isAdmin", props.userDetails.role == "Administrator" ? true : false);
        }

        handleDialog();
    }, [props.isOpenDialog])

    return (
        <>
            <Dialog className='AddUserDialog' open={openDialog} onClose={handleCloseDialog}>
                <DialogTitle className='DialogTitleDiv' sx={{ fontWeight: "bold" }}>Edit User</DialogTitle>
                <DialogContent>
                    <form onSubmit={handleSubmit(async (data: any) => {
                        //  data.id = 0;
                        props.onEditUser(props.userDetails.id, data.isAdmin, data.isHR);
                    })}>
                        <DialogContentText sx={{ p: 1 }}>
                            <Grid container spacing={2}>
                                <Grid item xs={12} md={12}>
                                    <div className='row'>
                                        <div className="form-lable col-4">
                                            <label>Administrator Role</label>
                                        </div>
                                        <div className='col-8'>
                                        <InputCheckboxFormControl
                                            initialValue={props.userDetails.role === "Administrator"}
                                            errors={errors}
                                            control={control}
                                            name="isAdmin"
                                            label="User has Administrator privileges"
                                        />
                                        </div>
                                    </div>
                                </Grid>
                                <Grid item xs={12} md={12}>
                                    <div className='row'>
                                        <div className="form-lable col-4">
                                            <label>HR</label>
                                        </div>
                                        <div className='col-8'>
                                        <InputCheckboxFormControl
                                            initialValue={props.userDetails.role === "HR"}
                                            errors={errors}
                                            control={control}
                                            name="isHR"
                                            label="User has HR privileges"
                                        />
                                        </div>
                                    </div>
                                </Grid>
                            </Grid>
                        </DialogContentText>
                        <DialogActions sx={{ p: 2 }}>
                            <Button sx={{ fontSize: "20px" }} variant="contained" onClick={handleCloseDialog}>Cancel</Button>
                            <Button type='submit' sx={{ fontSize: "20px" }} variant="contained" >Update</Button>
                        </DialogActions>
                    </form>
                </DialogContent>

            </Dialog >
        </>
    )
}

export default EditUser